import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { Banner } from "@ifgengineering/component-library";
import { storeViewAsExpiry } from "@helpers/viewAs/viewAsStorage";
import { useAppDispatch } from "@state/store";
import { exitViewAsSession } from "@state/viewAs/viewAs.actions";
import { viewAsSelector } from "@state/viewAs/viewAs.selectors";

const ViewAsBanner: FC = () => {
  const dispatch = useAppDispatch();
  const { active, targetName, sessionId, expiresAt } =
    useSelector(viewAsSelector);

  // The head script drops a stored id past this time, so a later tab opens as the staff member.
  useEffect(() => {
    if (active && sessionId && expiresAt) {
      storeViewAsExpiry(sessionId, expiresAt);
    }
  }, [active, sessionId, expiresAt]);

  if (!active) return null;

  return (
    <Banner
      bgColor="BLUE100"
      text={`Viewing as ${targetName || "investor"}. Read-only.`}
      CTAText="Exit"
      onClickCTA={() => dispatch(exitViewAsSession())}
      testId="view-as-exit"
    />
  );
};

export default ViewAsBanner;
